import { path } from 'Utility/ramdaReplacement';

export type TFunctionalPerformanceMgravisDocumentType = SafeExtract<TDocumentType, 'mgc' | 'mgadl'>;

const docType = (
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>,
  editing: string | undefined,
): string | undefined =>
  editing
    ? path(
        ['_type'],
        documents.find(d => d._id === editing),
      )
    : undefined;

export const getHeaderId = (
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>,
  editing?: string,
  viewing?: string,
): string => {
  if (!editing && !viewing) return 'functionalPerformanceMgravis.title';
  // handle both editing and viewing modes
  const docId = editing ?? viewing;
  // if the user is in editing or viewing mode and docType returns the doctype, return correct title for the header
  if (docType(documents, docId)) {
    return `functionalPerformanceMgravis.${docType(documents, docId)}`;
  }
  return 'functionalPerformanceMgravis.title';
};
export const getHeaderInfotext = (
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>,
  editing?: string,
  viewing?: string,
) => {
  if (!editing && !viewing) return;
  const docId = editing ?? viewing;
  if (docType(documents, docId) === 'mgc') {
    return `functionalPerformanceMgravis.labels.${docType(documents, docId)}.instruction`;
  }
  return undefined;
};
